import {Routes} from '@angular/router';
import {LoyaltyLayoutComponent} from "./components/loyalty-layout/loyalty-layout.component";
import {OnboardingComponent} from "./components/onboarding/onboarding.component";
import {AuthGuard} from './auth/auth-guard';
import {Application} from '../../../shared-lib/src/lib/services/auth';

export const routes: Routes = [
  {
    path: '',
    component: LoyaltyLayoutComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'onboarding',
    component: OnboardingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'congratulations/redeemed',
    loadComponent: () => import('./components/loyalty-redeemed-success/loyalty-redeemed-success.component')
      .then((m) => m.LoyaltyRedeemedSuccessComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'congratulations/mcard-event-test',
    loadComponent: () => import('shared-lib')
      .then((m) => m.MCardEventsTestComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'mcards/authentication',
    loadComponent: () => import('shared-lib')
      .then((m) => m.MCardsLoginComponent),
    data: {application: Application.LOYALTY}
  },
  {
    path: 'bounty-invitation',
    loadComponent: () => import('./components/ghost-merchant-bounty-invitation/ghost-merchant-bounty-invitation.component')
      .then((m) => m.GhostMerchantBountyInvitationComponent),
    canActivate: [AuthGuard],
  }
];
